import { connect } from 'react-redux';
import { authdata, get, getConfig } from '../../helpers';
import keyPageIds from '../../utilities/key-pages';

import Datasets from './datasets';

const numberOfSolutions = getConfig('numberOfSolutions');

const mapStateToProps = (state: RootStoreState): DatasetsProps => {
    const isLoggedIn = get(state, 'user.isLoggedIn', false);

    const datasets = get(state, 'datasets.all.response', []);
    let solutions = get(state, 'solutions.all.response', []) as APISolution[];
    const userEmail = state && state.user && state.user.userInfo ? state.user.userInfo.Email : '';
    solutions = authdata(solutions, userEmail);
    const featuredData = get(state, 'filters.featuredDatasets', []) as DatasetFeaturedAlternative[];
    const filterOptions = getConfig('components.filterOptions');
    const pageTextsData = get(state, 'shared.pageSections.data', []) as PageSections[];
    const bookmarkPreference = get(state.user, 'bookmarkPreference', { bookMarks: { datasets: [], solutions: [], queries: [], blueprints: [] }, bookmarksLoaded: false });
    const { bookMarks = { datasets: [], solutions: [], queries: [], blueprints: [] }, bookmarksLoaded = false } = bookmarkPreference;
    let filters: FilterObjects[] = [];
    const bookmarkFiletr = {
        filterKey: filterOptions.bookmark.filterKey,
        items: get(state, 'filters.bookmark', [])
    };

    const catagories = get(state, 'filters.categories', []);

    if (catagories.length) {
        filters = [
            {
                filterKey: filterOptions.category.filterKey,
                items: catagories
            },
            {
                filterKey: filterOptions.vendor.filterKey,
                items: get(state, 'filters.vendors', [])
            },
            {
                filterKey: filterOptions.industry.filterKey,
                items: get(state, 'filters.industries', [])
            },
            {
                filterKey: filterOptions.region.filterKey,
                items: get(state, 'filters.regions', [])
            },
            {
                filterKey: filterOptions.history.filterKey,
                items: get(state, 'filters.history', [])
            },
            {
                filterKey: filterOptions.pointInTime.filterKey,
                items: get(state, 'filters.pointInTime', [])
            },
            {
                filterKey: filterOptions.delivery.filterKey,
                items: get(state, 'filters.delivery', [])
            },
            {
                filterKey: filterOptions.deliveryPlatform.filterKey,
                items: get(state, 'filters.deliveryPlatform', [])
            }
        ];
        if (isLoggedIn) {
            filters.push(bookmarkFiletr);
        }
    }

    return {
        bookmarks: bookMarks,
        bookmarksLoaded,
        datasets,
        solutions: solutions
            .filter(solution => solution.FormOrderHomepageSolution)
            .sort((a, b) => a.FormOrderHomepageSolution - b.FormOrderHomepageSolution).slice(0, numberOfSolutions),
        filters,
        isLoggedIn: state.user.isLoggedIn,
        featuredData: featuredData
            .sort((a, b) => a.FormOrder - b.FormOrder)
            .map(dataset => {
                if (dataset.KeyMarketplaceDataset) return dataset.KeyMarketplaceDataset;
                if (dataset.KeyMarketplaceDatasetBundle) return dataset.KeyMarketplaceDatasetBundle;
                return 0;
            }),
        pageTextsData: pageTextsData.filter(x => x.KeyOnlinePage === keyPageIds.datasetsPage)
    };
};

export default connect(mapStateToProps)(Datasets);
